import React, { Fragment } from 'react';
import CheckBox from '../../artzu-ui/src/CheckBox';

const AnswerOption = ({
  answer,
  answerType,
  onAnswerSelected,
  answerContent
}) => (
  <Fragment>
    <li className="new-course__body__answerOptions__option">
      {/* <input
        type="radio"
        className="radioCustomButton"
        name="radioGroup"
        checked={answerType === answer}
        id={answerType}
        value={answerType}
        // disabled={answer}
        onChange={onAnswerSelected}
      /> */}

      <CheckBox
        label={answerContent}
        checkState={answerType === answer}
        id={answerType}
        value={answerType}
        onClick={isChecked => onAnswerSelected(answerType)}
        className={`checkBox--${
          answerType === answer ? 'checked' : 'unchecked'
        }`}
      />
      {/* <label
        className={`radioCustomLabel ${
          answerType === answer ? 'checked' : ''
        }`}   
        htmlFor={answerType}>
        {answerContent}
      </label> */}
    </li>
  </Fragment>
);

export default AnswerOption;



// WEBPACK FOOTER //
// ./src/components/NewExam/AnswerOption.js